import React from "react";
import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils/types";

export const PauseIcon = ({ className }: IconProps) => (
  <svg
    className={twMerge("h-10 w-10 text-white", className)}
    viewBox="0 0 38 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.623535"
      y="0.697266"
      width="15.2861"
      height="39"
      rx="2.28824"
      fill="currentColor"
    />
    <rect
      x="21.9097"
      y="0.697266"
      width="15.2861"
      height="39"
      rx="2.28824"
      fill="currentColor"
    />
  </svg>
);
